import { QueryKeysEnum } from '@/enums';
import {
  CreateScreeningTest,
  ScreeningTestEntity,
  ScreeningTestParams,
  SingleScreeningTestParams,
  UpdateScreeningTest,
} from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class ScreeningTestService extends BaseService<
  'screeningTest',
  ScreeningTestEntity,
  CreateScreeningTest
> {
  constructor() {
    super(QueryKeysEnum.FMT_SCREENING_TEST);
  }

  getScreeningTests = (
    params: ScreeningTestParams,
  ): Promise<ScreeningTestEntity[]> => {
    return APIService.get(this.path, { params });
  };

  getSingleScreeningTest = (
    params: SingleScreeningTestParams,
  ): Promise<ScreeningTestEntity> => {
    return APIService.get(this.path + '/single', { params });
  };

  updateScreeningTest = (payload: {
    id: string;
    data: UpdateScreeningTest;
  }): Promise<ScreeningTestEntity> => {
    const { id, data } = payload;
    return APIService.patch(this.path + '/' + id, data);
  };

  createManyScreeningTests = (
    payload: CreateScreeningTest,
  ): Promise<ScreeningTestEntity[]> => {
    return APIService.post(this.path, payload);
  };
}

export const screeningTestService = new ScreeningTestService();
